import { KnockFeedProvider, useKnockFeed } from '@knocklabs/react-notification-feed'
import React, { useEffect } from 'react'
import { useEffectOnce } from 'react-use'
import Cookies from 'universal-cookie'
import { config } from 'utils/config'
import { useCurrentUser } from 'modules/auth/useCurrentUser'
import { useCreateNotificationToken } from './queries/useNotificationToken'

// We only want to call this function when a valid knock token has been obtained
const WithNotifications = ({ children }: { children: React.ReactElement }) => {
  const { feedClient } = useKnockFeed()

  useEffect(() => {
    feedClient.fetch({ status: 'all' })
  }, [feedClient])

  return children
}

export const NotificationsProvider = ({ children }: { children: React.ReactElement }) => {
  const { user } = useCurrentUser()
  const cookies = new Cookies()
  const tokenCookie = cookies.get('knockToken')
  const [createToken, { data }] = useCreateNotificationToken((data) => {
    cookies.set('knockToken', data.createNotificationToken.payload.token, {
      expires: new Date(data.createNotificationToken.payload.expiresAt)
    })
  })

  const token = tokenCookie || data?.createNotificationToken.payload.token

  useEffectOnce(() => {
    if (!token) {
      createToken()
    }
  })

  if (!user) {
    return null
  }

  return (
    <KnockFeedProvider apiKey={config.knockApiPublicKey} feedId={config.knockFeedId} userId={user.firebaseUid} userToken={token} rootless>
      {token ? <WithNotifications>{children}</WithNotifications> : children}
    </KnockFeedProvider>
  )
}
